import { Flex, Typography } from "@aircall/tractor";
import { useTranslation } from "react-i18next";

import { useCall } from "@/hooks/useCall/useCall";

export function TranscriptionReadDuration() {
  const { t } = useTranslation();

  const { call } = useCall();

  if (!call) {
    return null;
  }

  return (
    <Flex flexDirection="column" gap="xxs" data-test="transcript-read-duration">
      <Typography variant="headingMediumS">{t("transcript")}</Typography>
      <Typography color="text-secondary" variant="bodyRegularS">
        {`${call.readingTime} ${t("transcription_header.reading_time")}`}
      </Typography>
    </Flex>
  );
}
